import { isEmpty } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

const ProductTags = ({
    tags,
    emptyMessage,
    emptyElement,
    center,
    removeTagHandler,
    isColumn,
    limit = null,
    keyName = "label",
    listClassName = "",
}) => {
    const { t } = useTranslation();
    const getEmptyContent = () => {
        if (emptyElement) {
            return emptyElement();
        } else {
            return <p>{emptyMessage || "---"}</p>;
        }
    };
    const renderTags = () => {
        const cappedTags = limit ? tags.slice(0, limit) : tags;
        return isEmpty(tags)
            ? getEmptyContent()
            : cappedTags.map((tag, index) => {
                  if (!tag) return;
                  return (
                      <li
                          key={tag?.index || index}
                          className={`tags-items ${listClassName}`}
                      >
                          {tag[keyName] || tag}
                          {tag.hidden && (
                              <span className="text-xxxs ml-0.5 opacity-80">
                                  {`(${t("hidden")?.toLowerCase()})`}
                              </span>
                          )}
                          {removeTagHandler && (
                              <i
                                  onClick={() =>
                                      removeTagHandler(
                                          tag[keyName] || tag,
                                          tag?.index || index
                                      )
                                  }
                                  className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                              ></i>
                          )}
                      </li>
                  );
              });
    };
    return (
        <>
            <ul
                className={`tags-wrapper flex flex-wrap ${
                    isColumn
                        ? "flex-col content-start justify-start items-start"
                        : ""
                } ${center ? "justify-center items-center" : ""}`}
            >
                {renderTags()}
                {limit && limit < tags.length && (
                    <li>
                        <p>...</p>
                    </li>
                )}
            </ul>
        </>
    );
};

export default ProductTags;
